import React, { Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

export class Recaptcha extends Component {

    recaptchaRef = React.createRef();
    static propTypes = {
        pageType: PropTypes.string,
        recaptchaTokenChange: PropTypes.func

    };

    componentWillMount() {

    }
    constructor(props) {
        super(props);

        this.state = {
            recaptchaValue: null
        };


    }

    handleRecaptchaChange(value) {
        this.props.recaptchaTokenChange(value);
        this.setState({ recaptchaValue: value });
    }

 
    componentDidMount() {
        // window.displayQuestion();
        //this.populateContest(this.props.userid);

        setTimeout(async () => {
            var token = await this.recaptchaRef.current.executeAsync();
            console.log(token);
            this.props.recaptchaTokenChange(token);            
        }, 100);
    }



    render() {

        return (

            <ReCAPTCHA
                ref={this.recaptchaRef}
                sitekey="6LcFFxkqAAAAAKrd_B0wLGRegMi7_Aoz-r-v9dcM" // Replace with your site key
                onChange={(token) => {
                   // console.log('reCAPTCHA token:', token);
                }}
                size="invisible" 
            />

        );

    }
}
